module.exports = __webpack_public_path__ + "element-icons.woff?2fad952a20fbbcfd1bf2ebb210dccf7a";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 662
// module chunks = 7